import request from "./request";

const Orcamento = {
  consultar: criterio =>
    request.get("/orcamentos", {
      params: {
        nome: criterio.nome,
        situacao: criterio.situacao,
        data: criterio.data,
        page: criterio.pagina,
        limit: criterio.limite
      }
    }),
  obterPercentuaisLeisSociais: () => request.get("/orcamentos/encargos"),
  criar: orcamento => request.post("/orcamentos/criar", orcamento),
  cadastrar: orcamento => request.post("/orcamentos", orcamento),
  alterar: orcamento => request.put(`/orcamentos/${orcamento.ID}`, orcamento),
  concluir: orcamento => request.put("/orcamentos", orcamento),
  excluir: id => request.del("/orcamentos", { params: { id } }),
  buscar: id => request.get(`/orcamentos/${id}`),
  buscarPlanilha: id => request.get(`/orcamentos/planilha/${id}`),
  atualizarPlanilha: orcamento => request.put("/orcamentos/planilha", orcamento),
  buscarCronograma: id => request.get(`/orcamentos/cronograma/${id}`),
  atualizarCronograma: estimativas => request.put("/orcamentos/cronograma", estimativas)
};

export default Orcamento;



// WEBPACK FOOTER //
// ./src/services/orcamento.js